import { connect } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

function ProtectedRoute({
  children,
  user,
  isInitial,
  role,
  permission,
}) {
  const location = useLocation();

  const isAuthenticated = !!user.isAuthenticated;
  console.log("🚀 [Debug] ~ ProtectedRoute ~ isAuthenticated:", isAuthenticated)
  const isRoleValid = role ? user.hasPriorityRole(role) : true;
  console.log("🚀 [Debug] ~ ProtectedRoute ~ isRoleValid:", isRoleValid)
  const isPermissionValid = permission
    ? user.withPermission(permission)
    : true;
  console.log("🚀 [Debug] ~ ProtectedRoute ~ isPermissionValid:", isPermissionValid)

  if (!isInitial) return <></>;

  return isAuthenticated && isRoleValid && isPermissionValid ? (
    (children || <Outlet />)
  ) : (
    <Navigate to={`/sign-out?redirect=${location.pathname}`} replace />
  );
}

export default connect(({ state: { ui, user } }) => ({
  user,
  isInitial: ui.isInitial,
}))(ProtectedRoute);
